import { useRef } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useAppInitialize } from './hooks/App/useAppInitialize';
import { useSubscription, UseSubscription } from './hooks/App/useSubscription';
import { useGetExposeExtendDataFromParent, ExtendData } from './hooks/App/useGetExposeExtendDataFromParent';
import { useEmitResetWindow } from './hooks/common/useEmitResetWindow';

import './global.module.css';
import { InitialLoading } from './components/App/InitialLoading';
import { History } from './components/App/History';
//import { SubscriptionAddButton } from './pages/SubscriptionAddButton';
import { ShippingAddressForm } from './pages/ShippingAddressForm';
import { ShippingAddress } from './pages/ShippingAddress';
import { PaymentMethodComplete } from './pages/PaymentMethodComplete';
import { PaymentMethod } from './pages/PaymentMethod';
import { SubscriptionCancelComplete } from './pages/SubscriptionCancelComplete';
import { SubscriptionCancel } from './pages/SubscriptionCancel';
import { NewSubscriptionDetail } from './pages/NewSubscriptionDetail';

export const App = () => {

  // アプリの初期化処理
  const token = useAppInitialize();

  // 本来的にはアプリでサポートしていないデータをthemeから取得する
  const extendData = useGetExposeExtendDataFromParent();

  // サブスクリプション情報の取得。
  const subscriptionRef = useSubscription(token);

  const setting = { token, extendData, subscriptionRef };

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  const [ { subscription } ] = subscriptionRef;
  useEmitResetWindow(rootElementReference, [subscription]);

  return (
  <div ref={rootElementReference}>
  {Boolean(token) ? (
    <BrowserRouter basename="/?path=">
      <History>
        <Switch>
          {/* 
          こちらはtheme側で走るアプリ初期化スクリプト(script.js)の仕様上
          絶対的に利用されないページのため、コメントアウトとする(参考のために記述)
          <Route path="/subscription/add">
            <SubscriptionAddButton token={token}/>
          </Route>*/}
          <Route path="/shippingAddress/form">
            <ShippingAddressForm setting={setting} />
          </Route>
          <Route path="/shippingAddress">
            <ShippingAddress setting={setting} />
          </Route>
          <Route path="/paymentMethod/complete">
            <PaymentMethodComplete/>
          </Route>
          <Route path="/paymentMethod">
            <PaymentMethod setting={setting} />
          </Route>
          <Route path="/cancel/complete">
            <SubscriptionCancelComplete/>
          </Route>
          <Route path="/cancel">
            <SubscriptionCancel setting={setting} />
          </Route>
          <Route path="/">
            <NewSubscriptionDetail setting={setting}/>
          </Route>
        </Switch>
      </History>
    </BrowserRouter>
  ) : (
    <InitialLoading/>
  )}
  </div>
  )
};

// types

export type Setting = {
  token: string,
  extendData: ExtendData | undefined,
  subscriptionRef: UseSubscription,
}